export default __webpack_public_path__ + "static/media/enable-icon.d0245f94.svg";